// extracted by mini-css-extract-plugin
module.exports = {"container":"DevTemplateSwitcher_container__LnYTo","label":"DevTemplateSwitcher_label__4mjP_","select":"DevTemplateSwitcher_select__umCl_"};